import environment from "environment";
import EffectUtility from "../../utilities/EffectUtility";
import TagModel from "./models/TagModel";

export default class TagEffect {
  // calling an API according to the TagModel
  static async requestTag(params) {
    const endpoint = environment.api.tag;
    return EffectUtility.getToModel(TagModel, endpoint, params);
  }

  static async requestTagFilter(params) {
    const endpoint = environment.api.tag;
    return EffectUtility.getToModel(TagModel, endpoint, params);
  }
}
